export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#1a5a9e] to-[#0f4a7f] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="bg-white rounded-lg p-4 inline-block mb-4">
              <img 
                src="https://static.readdy.ai/image/d9341b18b0ec25b73a2a0083444a8be7/cd3781bfb9ae66323e1c7ba0d9d5685e.png" 
                alt="NTC Tecnologia" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              28 anos oferecendo soluções de data center, backup corporativo e hospedagem de servidores em Manaus com excelência e confiabilidade.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Serviços</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#servicos" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Data Center em Manaus
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Backup Corporativo
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Hospedagem de Servidores
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Cloud Local
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Empresa</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#diferenciais" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#como-funciona" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contato</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#F5A623] mt-1"></i>
                <a href="tel:+5592991426889" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  (92) 99142-6889
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#F5A623] mt-1"></i>
                <a href="mailto:contato@neotec.inf.br" className="text-gray-300 hover:text-[#F5A623] transition-colors cursor-pointer">
                  contato@neotec.inf.br
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#F5A623] mt-1"></i>
                <span className="text-gray-300">
                  Rua Alexandre Magno, 519<br />
                  Parque 10 de Novembro<br />
                  Manaus - AM
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © 2025 NTC Tecnologia. Todos os direitos reservados.
              </p>
              <p className="text-gray-400 text-xs mt-1">
                CNPJ: 02.036.840/0001-30
              </p>
            </div>
            
            <div className="flex items-center gap-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#F5A623] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://www.instagram.com/neotec_tecnologia/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#F5A623] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#F5A623] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-[#F5A623] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}